export enum PreferredDutyCollectPartyType {
  FORWARDER = 'FORWARDER',
  CUSTOMS = 'CUSTOMS',
  BROKER = 'BROKER',
}
